<template>
  <v-card v-if="breadcrumbs.length > 1" :class="isMobile ? 'table-card pl-2 pr-2' : 'table-card'" elevation="0">
    <v-list flat class="d-inline-flex flex-wrap" :style="isMobile ? 'gap: 2px;' : 'gap: 12px;'">
      <v-list-item v-for="(item, i) in breadcrumbs"
        two-line
        :disabled="i === (breadcrumbs.length - 1)"
        :key="i"
        @click="onClick(i)"
        class="pa-0"
        style="flex: 0;">
        <v-list-item-content class="pa-0" style="gap: 2px;">
          <v-list-item-title class="text-subtitle-2">
            <span v-if="item.reportType === 'summary'">{{ $t('queues.reports.queueSummary.title') }}</span>
            <span v-else-if="item.reportType === 'callDetails'">{{ $t('queues.reports.callDetails.title') }}</span>
            <span v-else-if="item.reportType === 'agentDetails'">{{ $t('queues.reports.agent.title') }}</span>
            <span v-else>{{ $t('queues.reports.title') }}</span>
          </v-list-item-title>
          <v-list-item-subtitle class="text-caption d-flex align-center" style="gap: 2px;">
            <v-icon small>mdi-calendar</v-icon>&nbsp;
            <span v-if="item.scope === 'day'">{{ item.startDate.substring(0, 10) }}</span>
            <span v-else-if="item.scope === 'hour'" v-html="$t('queues.reports.scopeDisplays.hour',
              { date: item.startDate.substring(0, 10), start: item.startDate.substring(11, 16), end: item.endDate.substring(11, 16) })" />
            <span v-else v-html="$t('queues.reports.scopeDisplays.range', { start: item.startDate.substring(0, 10), end: item.endDate.substring(0, 10) })"></span>
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action v-if="i !== (breadcrumbs.length - 1)"><v-icon>mdi-chevron-right</v-icon></v-list-item-action>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  props: {
    breadcrumbs: {
      type: Array
    }
  },
  computed: {
    isMobile () {
      return this.$vuetify.breakpoint.mobile
    }
  },
  methods: {
    onClick (index) {
      const data = {
        ...this.breadcrumbs[index],
        breadcrumb_op: 'back',
        breadcrumb_idx: index
      }
      this.$emit('refreshData', data)
    }
  }
}
</script>
